import AllFilter from './AllFilter'

export default class CsrFilter extends AllFilter {
  filterJobs(data) {
    let filtered = [];
    $.each(data, (idx, job) => {
      if (this.filter == "all" || (job.csr_id == this.filter)) {
        filtered.push(job);
      }
    });
    return filtered;
  }
}
